// src/services/httpService.js
import axios from "axios";
import API_BASE_URL from "../config/config.js";
import { createCompanyContextInterceptor } from "./effectiveCompanyContext.js";
import {
  createAuthHeaderInterceptor,
  createUnauthorizedResponseInterceptor,
  dispatchUnauthorized,
} from "./authToken.js";

// FTR-0019: la autenticación viaja en Authorization: Bearer; el navegador ya no envía ni recibe la
// cookie de sesión (withCredentials: false), lo que elimina la dependencia de cookies cross-site.
const httpService = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: false,
});

// X-Hayllis-Company solo hacia la API de Winscore y solo con compañía efectiva activa (FTR-0012).
httpService.interceptors.request.use(createCompanyContextInterceptor(API_BASE_URL));
// Authorization: Bearer solo hacia la API de Winscore (nunca a /login ni a hosts externos) y un 401
// de la API descarta el token y avisa a la app (AuthSessionBridge) — FTR-0019.
httpService.interceptors.request.use(createAuthHeaderInterceptor(API_BASE_URL));
httpService.interceptors.response.use(
  undefined,
  createUnauthorizedResponseInterceptor(API_BASE_URL, dispatchUnauthorized)
);

export default httpService;
